import React from 'react'
import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import MainLayout from '@layouts/MainLayout'
import { PricingSection } from '@sections/pricing'
import { useTranslation, withTranslation } from 'next-i18next'
import { dehydrate, QueryClient } from '@tanstack/react-query'
import { prefetchPricing } from '@api/pricing'
import { PreFooterSection } from '@sections/home'

function Pricing() {
  const { t } = useTranslation(['meta'])
  return (
    <div>
      <Head>
        <title>{`${t('meta:pricing.title')} - Blue Assembly`}</title>
      </Head>
      <MainLayout navbarProps={{ dark: true }}>
        <PricingSection />
        <PreFooterSection />
      </MainLayout>
    </div>
  )
}

export const getStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient()
  await prefetchPricing(queryClient, locale)
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  }
}

export default withTranslation(['common'])(Pricing)
